module.exports = __webpack_public_path__ + "img/footer.fdb7c4fd.png";